import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePartyInputClass;
function SavePartyInput() {
  if (SavePartyInputClass === VOID) {
    class $ {
      constructor(partyId, name, email, pairingRule, badgesEnabled, defaultBadgeName, alternateBadgeName, callSignsEnabled, animationsEnabled, animationSpeed) {
        name = name === VOID ? Absent_getInstance() : name;
        email = email === VOID ? Absent_getInstance() : email;
        pairingRule = pairingRule === VOID ? Absent_getInstance() : pairingRule;
        badgesEnabled = badgesEnabled === VOID ? Absent_getInstance() : badgesEnabled;
        defaultBadgeName = defaultBadgeName === VOID ? Absent_getInstance() : defaultBadgeName;
        alternateBadgeName = alternateBadgeName === VOID ? Absent_getInstance() : alternateBadgeName;
        callSignsEnabled = callSignsEnabled === VOID ? Absent_getInstance() : callSignsEnabled;
        animationsEnabled = animationsEnabled === VOID ? Absent_getInstance() : animationsEnabled;
        animationSpeed = animationSpeed === VOID ? Absent_getInstance() : animationSpeed;
        this.k6q_1 = partyId;
        this.l6q_1 = name;
        this.m6q_1 = email;
        this.n6q_1 = pairingRule;
        this.o6q_1 = badgesEnabled;
        this.p6q_1 = defaultBadgeName;
        this.q6q_1 = alternateBadgeName;
        this.r6q_1 = callSignsEnabled;
        this.s6q_1 = animationsEnabled;
        this.t6q_1 = animationSpeed;
      }
      toString() {
        return 'SavePartyInput(partyId=' + this.k6q_1.toString() + ', name=' + toString(this.l6q_1) + ', email=' + toString(this.m6q_1) + ', pairingRule=' + toString(this.n6q_1) + ', badgesEnabled=' + toString(this.o6q_1) + ', defaultBadgeName=' + toString(this.p6q_1) + ', alternateBadgeName=' + toString(this.q6q_1) + ', callSignsEnabled=' + toString(this.r6q_1) + ', animationsEnabled=' + toString(this.s6q_1) + ', animationSpeed=' + toString(this.t6q_1) + ')';
      }
      hashCode() {
        var result = this.k6q_1.hashCode();
        result = imul(result, 31) + hashCode(this.l6q_1) | 0;
        result = imul(result, 31) + hashCode(this.m6q_1) | 0;
        result = imul(result, 31) + hashCode(this.n6q_1) | 0;
        result = imul(result, 31) + hashCode(this.o6q_1) | 0;
        result = imul(result, 31) + hashCode(this.p6q_1) | 0;
        result = imul(result, 31) + hashCode(this.q6q_1) | 0;
        result = imul(result, 31) + hashCode(this.r6q_1) | 0;
        result = imul(result, 31) + hashCode(this.s6q_1) | 0;
        result = imul(result, 31) + hashCode(this.t6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyInput()))
          return false;
        if (!this.k6q_1.equals(other.k6q_1))
          return false;
        if (!equals(this.l6q_1, other.l6q_1))
          return false;
        if (!equals(this.m6q_1, other.m6q_1))
          return false;
        if (!equals(this.n6q_1, other.n6q_1))
          return false;
        if (!equals(this.o6q_1, other.o6q_1))
          return false;
        if (!equals(this.p6q_1, other.p6q_1))
          return false;
        if (!equals(this.q6q_1, other.q6q_1))
          return false;
        if (!equals(this.r6q_1, other.r6q_1))
          return false;
        if (!equals(this.s6q_1, other.s6q_1))
          return false;
        if (!equals(this.t6q_1, other.t6q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyInput');
    SavePartyInputClass = $;
  }
  return SavePartyInputClass;
}
//region block: exports
export {
  SavePartyInput as SavePartyInput3ikp23en56cie,
};
//endregion

//# sourceMappingURL=SavePartyInput.mjs.map
